import { render, staticRenderFns } from "./RenderTable.vue?vue&type=template&id=68dd64f4&scoped=true"
import script from "./RenderTable.vue?vue&type=script&lang=ts"
export * from "./RenderTable.vue?vue&type=script&lang=ts"
import style0 from "./RenderTable.vue?vue&type=style&index=0&id=68dd64f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dd64f4",
  null
  
)

export default component.exports